import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { IKeyword } from 'modules/cms/seo/keyword/interfaces';

class KeywordService extends EntityApiService<IKeyword> {
  updatePriority = (keywordId: string, priority: string): any => {
    return ApiClientService.patch(this.getPath(`/${keywordId}`), {
      priority,
    });
  };
}

export default new KeywordService('/ms-cms/api/seo/keywords');
